/*
 * @Author: changcheng
 * @LastEditTime: 2023-08-23 15:41:55
 */
import { Menu } from "antd";
import { useEffect, useState } from "react";
import { RootState } from "@root/store/index";
import { UserDetailInfoProps } from "@root/actions/index";
import { useSelector } from "react-redux";
import lock from "@root/img/lock.png";
import {
  getUserLearn,
  getLearnClinicCourseList,
  getFinishClinicCourseList,
  getLearnSpecialCourseList,
  getFinishSpecialCourseList,
  testJumpLive,
} from "@root/common/service";
import {
  MailOutlined,
  AppstoreOutlined,
  BookOutlined,
} from "@ant-design/icons";
import CourseList from "@root/components/courselist/index";
import "./_style.scss";
const items = [
  { label: "正在学习课程", key: "learn", icon: <MailOutlined /> },
  { label: "已完成课程", key: "finish", icon: <AppstoreOutlined /> },
  // { label: "待学习课程", key: "unlearn", icon: <SettingOutlined /> },
];
interface learnInfoProps {
  /*** 当日学习时长 */
  dayWatchTime: number;
  /*** 当日学习时长*/
  dayWatchTimeText: string;
  /*** 本院学习排名*/
  instituteLearnRanking: number;
  /*** 本院学习总人数*/
  instituteUserCount: number;
  /*** 全省学习排名*/
  provinceLearnRanking: number;
  /*** 全省学习总人数 */
  provinceUserCount: number;
  /*** 本学科排名*/
  subjectLearnRanking: number;
  /*** 本学科总人数据*/
  subjectUserCount: number;
  /*** 累计学习时长*/
  totalWatchTime: number;
  /*** 累计学习时长*/
  totalWatchTimeText: string;
  /*** 课程时长*/
  courseDurationText: string;
}
interface courseListProps {
  courseId: number;
  courseWatchTimeText: string;
  courseDurationText: string;
  videoCount: number;
  courseName: number;
  courseImage: string;
}
// 根据类型调用不同的接口，因为返回参数都一致
const apiMapByCourseStatus = new Map([
  ["clinic-learn", getLearnClinicCourseList],
  ["clinic-finish", getFinishClinicCourseList],
  ["special-learn", getLearnSpecialCourseList],
  ["special-finish", getFinishSpecialCourseList],
]);
export default function MyCourse() {
  const [key, setKey] = useState("learn");
  const [learnInfo, setLearnInfo] = useState<Partial<learnInfoProps>>({});
  const [courseList, setCourseList] = useState([]);
  const [pageNum] = useState(1);
  const { userDetailInfo } = useSelector((state: RootState) => state.userInfo);
  const { status } = userDetailInfo as UserDetailInfoProps;
  const pageSize = 10;
  /**
   * 获取学习信息
   */
  const getLearnInfo = async () => {
    const { data } = await getUserLearn();
    setLearnInfo(data);
  };
  const getCurrentTypeCourse = async (type: string) => {
    const {
      data: { rows = [] },
    } = await (apiMapByCourseStatus.get(type) as any)({ pageNum, pageSize });
    setCourseList(
      rows.map((item: courseListProps) => {
        return {
          id: item.courseId,
          courseWatchTimeText: item.courseWatchTimeText,
          courseDurationText: item.courseDurationText,
          videoCount: item.videoCount,
          name: item.courseName,
          imageAllPath: item.courseImage,
        };
      })
    );
  };
  useEffect(() => {
    getLearnInfo();
    getCurrentTypeCourse("clinic-learn");
  }, []);
  return (
    <div className="userCenter_course">
      {status === "0" && (
        <div className="learningStatistics">
          <div>
            <span>{learnInfo.dayWatchTimeText}</span>
            <p>今日学习时长</p>
          </div>
          <div>
            <span>{learnInfo.totalWatchTimeText}</span>
            <p>累计学习时长</p>
          </div>
          {/* <div
            onClick={async () => {
              const { data } = await testJumpLive();
              window.open(data);
            }}
          >
            <span>{learnInfo.totalWatchTimeText}</span>
            <p>banner测试</p>
          </div> */}
          {/* <div>
            <span>
              {learnInfo.instituteLearnRanking}/{learnInfo.subjectUserCount}
            </span>
            <p>本学科学习排名</p>
          </div> */}
          {/* <div>
            <span>
              {learnInfo.instituteLearnRanking}/{learnInfo.instituteUserCount}
            </span>
            <p>本院学习排名</p>
          </div> */}
          {/* <div>
            <span>
              {learnInfo.provinceLearnRanking}/{learnInfo.provinceUserCount}
            </span>
            <p>全省学习排名</p>
          </div> */}
        </div>
      )}
      {status === "0" && (
        <div>
          <Menu mode="horizontal" defaultSelectedKeys={["clinic-learn"]}>
            <Menu.SubMenu key="clinic" title="临床课程" icon={<BookOutlined />}>
              {items.map((item) => (
                <Menu.Item
                  key={`clinic-${item.key}`}
                  icon={<MailOutlined />}
                  onClick={(item) => {
                    const { key } = item;
                    getCurrentTypeCourse(key);
                  }}
                >
                  {item.label}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
            <Menu.SubMenu
              key="special"
              title="专项课程"
              icon={<BookOutlined />}
            >
              {items.map((item) => (
                <Menu.Item
                  key={`special-${item.key}`}
                  icon={<MailOutlined />}
                  onClick={(item) => {
                    const { key } = item;
                    getCurrentTypeCourse(key);
                  }}
                >
                  {item.label}
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          </Menu>
          <CourseList data={courseList} />
        </div>
      )}
      {status !== "0" && (
        <div className="lock_container">
          <img src={lock} alt="" />
          <p>请联系所在县医院管理员进行信息审核，审核通过后继续学习</p>
        </div>
      )}
    </div>
  );
}
